<template>
  <!-- 财务管理 -->
  <div>
    <div class="page-container" v-if="!showDownloadCenter">
    <div class="page_title">
      <div class="page_title_desc">电话通知支付流水查询</div>
      <kt-button
          icon=""
          label="下载中心"
          perms="-1"
          type="text"
          size="medium"
          @click="toDownloadCenter"/>
    </div>
    <el-divider></el-divider>
    <!--工具栏-->
    <div class="toolbar">
      <el-form :inline="true" :model="filterForm" :size="size">
        <el-form-item label="">
          <el-input v-model="filterForm.driverName" placeholder="司机姓名" clearable></el-input>
        </el-form-item>
        
        <el-form-item label="">
          <el-input v-model="filterForm.driverPhone" placeholder="司机电话" clearable></el-input>
        </el-form-item>
        <el-form-item label="">
          <el-input v-model="filterForm.transNo" placeholder="交易流水编号" clearable></el-input>
        </el-form-item>
        <el-form-item label="">
          <el-input v-model="filterForm.channelTransNo" placeholder="微信交易流水编号"  clearable=""/>
        </el-form-item>
        <el-form-item label>
          <el-date-picker
            v-model="filterForm.transTime"
            type="datetimerange"
            value-format="yyyy-MM-dd HH:mm:ss"
            range-separator="至"
            start-placeholder="交易开始时间"
            end-placeholder="交易结束时间"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label>
          <el-select v-model="filterForm.tradeType" clearable placeholder="请选择交易类型">
            <el-option
              v-for="item in typeList"
              :key="item.code"
              :label="item.name"
              :value="item.code"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label>
          <el-select v-model="filterForm.transStatus" clearable placeholder="请选择交易状态">
            <el-option
              v-for="item in statusList"
              :key="item.code"
              :label="item.name"
              :value="item.code"
            ></el-option>
          </el-select>
        </el-form-item>
        
        <el-form-item>
          <kt-button
            icon="fa fa-search"
            label="搜索"
            perms="-1"
            type="primary"
            @click="handleSearch"
          />
        </el-form-item>
        <el-form-item>
          <kt-button
            icon="fa fa-share"
            label="重置"
            perms="-1"
            @click="handleReset"
            type="primary"
          />
        </el-form-item>
        <el-form-item>
          <kt-button
            icon="fa fa-credit-card-alt"
            label="退款"
            perms="30911"
            type="danger"
            @click="handleRefund"
          />
        </el-form-item>
        <el-form-item>
          <kt-button
            icon="fa fa-sign-out"
            label="导出"
            v-loading.fullscreen.lock="fullscreenLoading"
            perms="30910"
            type="primary"
            @click="showExportDialog=true"
          />
        </el-form-item>
      </el-form>
    </div>
    <!--表格树内容栏-->
    <el-table
      v-loading="loading"
      :data="financeList"
      stripe
      size="mini"
      style="width: 100%;"
      row-key="transNo"
    >
      <el-table-column type="index" width="50" align="center" fixed label="序号"></el-table-column>
      <el-table-column prop="transNo" align="center"  label="交易流水编号"></el-table-column>
      <el-table-column prop="channelTransNo" align="center"  label="微信交易流水编号"></el-table-column>
      <el-table-column prop="transTime" align="center" width="150" label="交易时间">
      </el-table-column>
      <el-table-column prop="driverName" align="center" width="100" label="司机姓名"></el-table-column>
      <el-table-column prop="driverPhone" align="center" width="100" label="手机号"></el-table-column>
      <el-table-column prop="tradeType" align="center" width="120" label="交易类型"></el-table-column>
      <el-table-column prop="transStatus" align="center" width="120" label="交易状态"></el-table-column>
      <el-table-column prop="remark" align="center" label="备注">
        <template slot-scope="scope">
          <span>{{scope.row.remark || '无'}}</span>
        </template>
      </el-table-column>
    </el-table>
    <!--分页栏-->
    <div class="toolbar" style="padding:20px;">
      <el-pagination
        background
        layout="total, prev, pager, next"
        @current-change="refreshPageRequest"
        :current-page="pageNo"
        :page-size="pageSize"
        :total="totalSize"
        style="float:right;"
      ></el-pagination>
    </div>
    <!-- 退款弹窗 -->
    <el-dialog
      title="退款"
      :visible.sync="refundDialogVisible"
      :lock-scroll="true"
      :close-on-click-modal="false"
      @close="dialogCloseCallback"
      width="500px"
    >
      <div>
        <el-form
          :model="refundForm"
          :rules="dataRules"
          ref="refundForm"
          label-width="150px"
          :size="size"
          class="dataForm"
        >
          <el-row :gutter="10" >
            <el-col :span="18">
              <el-form-item label="微信交易流水编号：">
                <el-input v-model="searchPayNo" placeholder="请输入微信交易流水编号" clearable :disabled="!!refundForm.channelTransNo"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="2" v-if="!refundForm.channelTransNo">
              <kt-button
                icon="fa fa-search"
                label="查找"
                perms="-1"
                type="primary"
                style="margin-top: 3px"
                v-loading="searchLoading"
                @click="handleSearchWaybill"
              />
            </el-col>
          </el-row>
          <el-row  >
            <el-col :span="23">
              <el-form-item label="司机姓名：" v-if="refundForm.channelTransNo">
                <span>{{refundForm.driverName }}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row >
            <el-col :span="23">
              <el-form-item label="手机号：" v-if="refundForm.channelTransNo">
                <span>{{refundForm.driverPhone}}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row >
            <el-col :span="23">
              <el-form-item label="交易金额：" v-if="refundForm.channelTransNo">
                <span>{{refundForm.tradeAmount}}元</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row v-if="refundForm.channelTransNo">
            <el-col :span="18">
              <el-form-item label="退款金额：" prop="refundAmount">
                <el-input v-model="refundForm.refundAmount" placeholder="请输入退款金额" clearable></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row >
            <el-col :span="20" v-if="refundForm.channelTransNo">
              <el-form-item label="退款原因：" prop="remark">
                <el-input
                  v-model="refundForm.remark"
                  type="textarea"
                  placeholder="请输入退款原因，20个字以内"
                  maxlength="20"
                  show-word-limit
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer" v-if="refundForm.channelTransNo">
        <el-button size="small" @click="refundDialogVisible = false">取 消</el-button>
        <el-button size="small" type="primary" @click="submitForm">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 导出弹窗 本来打算做公共的 先各走各的 -->
    <el-dialog
        title="提示"
        center
        :visible.sync="showExportDialog"
        :close-on-click-modal="false"
        width="400px">
        <div style="text-align:center">
          <span >请确认是否导出？</span>
        <br/>
        <span >导出的数据请在下载中心内进行下载</span>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="showExportDialog = false">取 消</el-button>
          <el-button size="mini" type="primary" @click="newExportData">确 定</el-button>
        </span>
      </el-dialog>
    
  </div>
  <download-center v-if="showDownloadCenter" @Adjust="AdjustFun"></download-center>
  </div>
</template>

<script>
import KtButton from "@/components/Core/KtButton";
import DownloadCenter from './NoticeDownload.vue'
let that = null;
export default {
  components: {
    KtButton,
    DownloadCenter
  },
  data() {
    return {
      size: "small",
      pageNo: 1,
      pageSize: 10,
      totalSize: 0,
      loading: false,
      fullscreenLoading: false,
      searchLoading: false,
      financeList: [],
      allCoalmineList: [],
      purchaserList: [],
      parkList: [],
      typeList: [],
      statusList:[],
      paySceneList:[],
      refundDialogVisible: false,
      filterForm: {
        coalMineName: "",
        carLicensePlateNo:'',
        purchaseName: "",
        parkName: "",
        tradeType: "",
        transTime: "",
        transNo:'',
        waybillNo:'',
        driverName:'',
        transStatus :'',
        channelTransNo:''
      },
      waybillStatusList:[],
      showDownloadCenter: false,
      searchPayNo: "",
      refundForm: {},
      showExportDialog:false,
      dataRules: {
        refundAmount:[{required:true , validator: this.checkAmount() }],
        remark: [{ required: true, message: "请输入退款原因", trigger: "blur" }]
      }
    };
  },
  created() {
    that = this;
  },
  mounted() {
    // this.getPaySenceList()
    this.getPurchaseAccountList();
    this.getTypeList();
    this.getStatusList()
    // this.getAllCoalmineList();
    // this.getPetPurchaserList();
    // this.getSimpleParkList();
    // this.getWaybillNoStatus()
  },
  methods: {
    checkAmount(){
      return (rule, value, callback) => {
        if(!value){
          return  callback(new Error("请输入退款金额"))
        }
        if (value < 0 || value == 0) {
          return callback(new Error("请输入大于0的数字"));
        }
        this.refundForm.refundAmount = value.match(/^\d*(\.?\d{0,2})/g)[0]
        return callback()
      }
    },
    //获取运单状态
    getWaybillNoStatus(){
      this.$api.waybill.mGetAllStatusList().then((res) => {
        if (res.data && res.data.length > 0) {
        this.waybillStatusList = res.data.filter((item) => {
          return item.code != 16;
        });
      } else {
        this.waybillStatusList = [];
      }
      })
    },
    //获取交易场景
    getPaySenceList(){
      this.$api.finance.paySceneList({}).then((res) => {
        this.paySceneList = res.data.filter((item) => {
          return item.code!==1
        })
      })
    },
    // 获取财务列表
    async getPurchaseAccountList() {
      this.loading = true;
      const params = {
        pageNo: this.pageNo,
        pageSize: this.pageSize
      };
      let index = 0;
      for (let key in this.filterForm) {
        const val = this.filterForm[key];
        if (val === 0 ||(val !== ""&&val)) {
          params["searchFieldList[" + index + "].fieldName"] = key;
          if (key === "transTime") {
            params["searchFieldList[" + index + "].rangeMinValue"] = val[0];
            params["searchFieldList[" + index + "].rangeMaxValue"] = val[1];
          } else {
            params["searchFieldList[" + index + "].singleValue"] = val;
          }
          index++;
        }
      }
      let res = await this.$api.phoneService.mGetFlowList(params);
      const data = res.data;
      this.totalSize = data.totalSize || 0;
      if (data && data.dtoList && data.dtoList.length > 0) {
        this.financeList = data.dtoList;
      } else {
        this.financeList = [];
      }
      this.loading = false;
    },
    // 换页刷新
    refreshPageRequest(pageNo) {
      this.pageNo = pageNo;
      this.getPurchaseAccountList();
    },
    // 搜索
    handleSearch() {
      this.pageNo = 1;
      this.getPurchaseAccountList();
    },
    getStatusList(){
      this.$api.finance.getStatusList({

      }).then((res) => {
        this.statusList = res.data
      })
    },
    handleReset() {
      this.pageNo =1 
      this.filterForm = {
        coalMineName: "",
        purchaseName: "",
        parkName: "",
        tradeType: "",
        transTime: ""
      };
      this.handleSearch();
    },
    // 显示退款
    handleRefund() {
      this.refundDialogVisible = true;
    },
    // 获取所有煤矿
    getAllCoalmineList() {
      this.$api.finance.getAllCoalmineList().then(res => {
        if (res.data && res.data.length > 0) {
          this.allCoalmineList = res.data;
        } else {
          this.allCoalmineList = [];
        }
      });
    },
    AdjustFun(val){
      this.showDownloadCenter = !val
    },
    // 获取采购方列表
    async getPetPurchaserList() {
      let res = await this.$api.purchaser.mGetEjyAllPurchaseList()
      if (res.data && res.data.length > 0) {
        this.purchaserList = res.data.filter(item => item.name)
      } else {
        this.purchaserList = [];
      }
    },
    // 停车场名称--下拉
    getSimpleParkList() {
      this.$api.finance.getSimpleParkList().then(res => {
        if (res.data && res.data.length > 0) {
          this.parkList = res.data;
        } else {
          this.parkList = [];
        }
      });
    },
    // 获取所有交易类型状态
    getTypeList() {
      this.$api.finance.getTypeList().then(res => {
        if (res.data && res.data.length > 0) {
          this.typeList = res.data.filter((item) => {
            return item.code!==3
          });
        } else {
          this.typeList = [];
        }
      });
    },
    handleSearchWaybill() {
      if (this.searchPayNo == "") {
        this.$message({
          message: "请输入微信交易流水编号",
          type: "warning"
        });
        return false;
      }
      this.searchLoading = true;
      let params = {
        'searchFieldList[0].fieldName' : 'channelTransNo',
        'searchFieldList[0].singleValue' : this.searchPayNo
      }
      this.$api.phoneService
        .mGetFlowList(params)
        .then(res => {
          if (res.data&&res.data.dtoList) {
            this.refundForm = res.data.dtoList[0];
            this.refundForm.remark = "";
          } else {
            this.refundForm = {};
            this.$message({
              type:'error',
              message:'未查询到该交易流水',
              offset:300
            })
          }
          this.searchLoading = false;
        })
        .catch(res => {
          this.refundForm = {};
          this.searchLoading = false;
        });
    },
    dialogCloseCallback() {
      if (this.$refs.refundForm) {
        this.refundForm = {};
        this.searchPayNo = "";
        this.$refs["refundForm"].resetFields();
      }
    },
    // 表单提交
    submitForm() {
      this.$refs["refundForm"].validate(valid => {
        if (valid) {
          const params = {
            wxTransNo: this.refundForm.channelTransNo,
            refundAmount: this.refundForm.refundAmount,
            remark: this.refundForm.remark
          };
          this.$api.finance.voiceRefund(params).then(res => {
            this.$message({ message: "操作成功", type: "success" });
            this.dialogCloseCallback();
            this.refundDialogVisible = false;
            this.getPurchaseAccountList();
          });
        }
      });
    },

    //去下载中心
    toDownloadCenter(){
      this.showDownloadCenter = true
    }, 
    newExportData(){
      const params = {
        pageNo: 1,
        pageSize: 10000,
      };
      let index = 0;
      for (let key in this.filterForm) {
        const val = this.filterForm[key];
        if (val === 0 ||(val !== ""&&val)) {
          params["searchFieldList[" + index + "].fieldName"] = key;
          if (key === "transTime") {
            params["searchFieldList[" + index + "].rangeMinValue"] = val[0];
            params["searchFieldList[" + index + "].rangeMaxValue"] = val[1];
          } else {
            params["searchFieldList[" + index + "].singleValue"] = val;
          }
          index++;
        }
      }
      this.$api.finance.voiceExport(params).then(res => {
        this.$message({
          type:'success',
          offset:300,
          message:'成功创建下载任务，请稍后在下载中心内进行下载',
        })
        this.showExportDialog = false
      });
    },
  },
  computed:{
  }
};
</script>

<style lang="scss" scoped>
.page-container{
  box-sizing: border-box;
  padding: 10px;
}
.toolbar {
  width: 100%;
  box-sizing: border-box;
  padding: 10px 10px 30px;
}
</style>
